export class SlamChampionship {
    constructor(data) {

        this.id = data.id;
        this.name = data && data.name ? data.name : "";
        this.desc = data && data.desc ? data.desc : "";
    }
}